import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['modal']

  modal(_e) {
    const spinerHTML =
      '<div class="spinner-border partner-wait" role="status"><span class="sr-only">Loading...</span></div>'

    $('turbo-frame#partner').html(spinerHTML)
    $(this.modalTarget).modal('show')
  }

  visit(e) {
    e.currentTarget.getElementsByTagName('a')[0].click()
  }
}
